import React, { useState, useEffect } from 'react';

import { useHistory } from 'react-router-dom';

import { trackPromise } from 'react-promise-tracker';
import { useSnackBar } from '../../../hooks/snackBar';

import { cargos } from '../../../services/cargosseller';
import services from '../../../services';

import {
    cadastrarUsuarioSeller
} from '../../../services/http/SellerAdminstradorService/usuarioSellerService';

import {
    aceitarTermo
} from '../../../services/http/sellerService';

import FormControl from '@material-ui/core/FormControl';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import Select from '@material-ui/core/Select';
import Checkbox from '@material-ui/core/Checkbox';

import './styles.scss';

const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: 48 * 4.5 + 8,
            width: 250
        }
    },
    getContentAnchorEl: null,
    anchorOrigin: {
        vertical: "bottom",
        horizontal: "center"
    },
    transformOrigin: {
        vertical: "top",
        horizontal: "center"
    },
    variant: "menu"
};


const FormCadUsuarioPrimeiroAcesso = ({
    idEmpresa,
    closeModal
}) => {
    const history = useHistory();

    const { addSnackBar } = useSnackBar();
    const [isFormInvalid, setIsFormInvalid] = useState(false);
    const [senhaCorreta, setSenhaCorreta] = useState(true);
    const [senhaFormatoCorreto, setSenhaFormatoCorreto] = useState(true);
    const [idUsuarioSeller, setIdUsuarioSeller] = useState(null);
    const [senha, setSenha] = useState("");
    const [width, setWidth] = useState(window.innerWidth);

    const [usuario, setUsuario] = useState({
        nome: "",
        email: "",
        telefone: "",
        cargo: "",
        senha: "",
        receberNotificacao: true,
        id: ""
    });

    const changeUsuario = (value, propertie) => {
        setUsuario((prevent) => ({
            ...prevent,
            [propertie]: value
        }));
    }

    const validarFomatoSenha = () => {
        var regularExpression = /^(?=.*[0-9])(?=.*[!@#$%^&*])[a-zA-Z0-9!@#$%^&*]{8,16}$/;
        var passou = regularExpression.test(usuario?.senha)
        setSenhaFormatoCorreto(passou);

        if (senha != usuario.senha) {
            console.log('porra');
            setSenhaCorreta(false);
            return false;
        }
        setSenhaCorreta(true);
        return true;
    }

    const conferirSenha = () => {
        if (!(!usuario.senha && idUsuarioSeller)) {
            return validarFomatoSenha();
        }

        return true;
    }

    const submitUsuarioSeller = () => {
        trackPromise(
            aceitarTermo(idEmpresa)
                .then(res => {
                    if (!res.fail) {
                        if (conferirSenha() && !validarForm()) {
                            removerMascaraTelefone();
                            trackPromise(
                                cadastrarUsuarioSeller(usuario, idEmpresa)
                                    .then(res => {
                                        
                                        if (res.data) {
                                            addSnackBar({ message: 'Cadastrado com sucesso', info: 'success', open: true });
                                            closeModal();
                                        } else {
                                            addSnackBar({ message: 'Não foi possível cadastrar usuário', info: 'error', open: true });
                                        }
                                    }).catch(error => {
                                        console.log(error);
                                        addSnackBar({ message: 'Erro ao cadastrar usuário', info: 'error', open: true });
                                    })
                            )
                
                        }               
                    }
                })
        )
    }

    const validarForm = () => {
        var isInvalidForm = false;
        if (!usuario?.nome) isInvalidForm = true;
        if (!usuario?.email) isInvalidForm = true;
        if (usuario?.senha?.length < 8) isInvalidForm = true;
        if (!usuario?.telefone) isInvalidForm = true;
        if (!senhaCorreta) isInvalidForm = true;
        setIsFormInvalid(isInvalidForm);

        return isInvalidForm;
    }

    const removerMascaraTelefone = () => {
        if (usuario?.telefone.includes("(")) {
            usuario.telefone = services.mask.unMask(usuario?.telefone);
        }
    }

    const msgSenha = () => {
        if (isFormInvalid && usuario?.senha.length < 8) {
            return 'Mínimo 8 dígitos e conter números, letras maiúsculas, minúsculas e caractere especial. Ex:Senh@123';
        } else if (!senhaFormatoCorreto) {
            return "Mínimo 8 dígitos e conter números, letras maiúsculas, minúsculas e caractere especial. Ex:Senh@123"
        }
    }

    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }

    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    return (
        <div>
            <div className={"row mt20 " + (width<768?"wmin250 mlMin75":"") } >
                <div className='col-md-12'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Nome"
                            size="small"
                            onChange={event => changeUsuario(event.target.value, 'nome')}
                            value={usuario?.nome || ''}
                            helperText={isFormInvalid && !usuario?.nome && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.nome ? true : false} />
                    </FormControl>
                </div>
            </div>
            <div className={"row " + (width<768?"wmin250 mlMin75":"") } >
                <div className='col-md-12'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="E-mail"
                            size="small"
                            onChange={event => changeUsuario(event.target.value, 'email')}
                            value={usuario?.email || ''}
                            helperText={isFormInvalid && !usuario?.email && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.email ? true : false} />
                    </FormControl>
                </div>
            </div>
            <div className={"row " + (width<768?"wmin250 mlMin75":"") }>
                <div className='col-md-6'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Celular"
                            size="small"
                            inputProps={{ maxLength: 15 }}
                            onChange={event => changeUsuario(event.target.value, 'telefone')}
                            value={services.mask.celular(usuario?.telefone) || ''}
                            helperText={isFormInvalid && !usuario?.telefone && 'Campo obrigatório'}
                            error={isFormInvalid && !usuario?.telefone ? true : false} />
                    </FormControl>
                </div>
                <div className="col-sm-6 col-md-6 col-lg-6"> 
                    <FormControl >

                        <InputLabel id="demo-simple-select-helper-label">Cargo</InputLabel>
                        <Select
                            required
                            className="select"
                            variant="outlined"
                            value={usuario?.cargo || 'selecione'}
                            label="Cargo"
                            onChange={event => changeUsuario(event.target.value, 'cargo')}
                            MenuProps={MenuProps}
                        >
                            <MenuItem disabled={true} value={"selecione"}>
                                <em>Cargo</em>
                            </MenuItem>

                            {cargos.map(cargo =>
                                <MenuItem value={cargo}>{cargo}</MenuItem>
                            )}
                        </Select>

                        {isFormInvalid && !usuario?.cargo &&
                            <FormHelperText>Campo obrigatório</FormHelperText>
                        }
                    </FormControl>
                </div>
            </div>
            <div className={"row " + (width<768?"wmin250 mlMin75":"") }>
                <div className='col-md-6'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Senha"
                            type="password"
                            size="small"
                            onChange={event => changeUsuario(event.target.value.trim(), 'senha')}
                            value={usuario?.senha || ''}
                            helperText={msgSenha()}
                            error={services.mask.validarSenha(usuario?.senha) ? true : false} />
                    </FormControl>
                </div>
                <div className='col-md-6'>
                    <FormControl >
                        <TextField fullWidth
                            id="standard-bare"
                            variant="outlined"
                            label="Confirmar Senha"
                            type="password"
                            size="small"
                            onChange={(event) => setSenha(event.target.value)}
                            defaultValue={''}
                            helperText={!senhaCorreta ? "A senha não esta igual" : ""}
                            error={!senhaCorreta || isFormInvalid ? true : false} />
                    </FormControl>
                </div>
            </div>       
            <div className={"row " + (width<768?"wmin250 mlMin75":"") }>
                <div className="col-sm-12 col-md-12 col-lg-12 mt10 flex flex-end buttons">
                    <button className="col-sm-8 col-md-8 col-lg-8 buton-green" onClick={submitUsuarioSeller}>SALVAR</button>
                </div>
            </div>
            <div className='mt20'></div>
        </div>
    );
}

export default FormCadUsuarioPrimeiroAcesso;